import { createColumnHelper } from '@tanstack/react-table';
import { SortableHeadCell, TextCell } from 'components/tables/cells';
import { TextColumnProps } from '../../tables/columnTypes';
import { SystemEntity } from 'domain/systemEntity/interfaces/SystemEntity';
import LinkCell from 'components/tables/cells/LinkCell/LinkCell';
import { toDefaultDateFormatOrNotAvailable } from 'utils/dateUtils';

const columnHelper = createColumnHelper<SystemEntity>();

export const systemEntitiesTableColumns = {
	name: (overrideProps?: TextColumnProps<SystemEntity>) =>
		columnHelper.accessor((row) => row.displayName, {
			id: 'displayName',
			enableSorting: true,
			size: 100,
			header: ({ header }) => (
				<SortableHeadCell
					text="Name"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<TextCell
					text={info.getValue()}
					{...overrideProps?.cellProps}
				/>
			),
			...overrideProps?.columnDefProps,
		}),

	company: (overrideProps?: TextColumnProps<SystemEntity>) =>
		columnHelper.accessor((row) => row.companyName, {
			id: 'company',
			enableSorting: true,
			header: ({ header }) => (
				<SortableHeadCell
					text="Company"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) =>
				info.row.original.companyId ? (
					<LinkCell
						url={`/companies/${info.row.original.companyId}`}
						text={info.getValue() ?? '-'}
						{...overrideProps?.cellProps}
					/>
				) : (
					<TextCell
						text={info.getValue() ?? '-'}
						{...overrideProps?.cellProps}
					/>
				),
			...overrideProps?.columnDefProps,
		}),
	created: (overrideProps?: TextColumnProps<SystemEntity>) =>
		columnHelper.accessor((row) => row.createdAt, {
			id: 'created',
			enableSorting: true,
			header: ({ header }) => (
				<SortableHeadCell
					text="Created"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<TextCell
					text={toDefaultDateFormatOrNotAvailable(info.getValue())}
					{...overrideProps?.cellProps}
				/>
			),
			...overrideProps?.columnDefProps,
		}),
};
